import React, { useEffect, useState } from 'react';
import OverNLBADetailLayout from '../components/OverNLBADetailLayout';
import { contentAPI } from '../services/api';
import banner from '../assets/LINK-Fotografie-1806_47909.jpg';
import './OverNLBA.css';

const TEAM_SECTIONS = [
  { key: 'management_staff', title: 'Management en Staf' },
  { key: 'docenten', title: 'Docenten' },
  { key: 'commissies', title: 'Commissies' }
];

const normalizeTeamGroup = (value) => {
  if (value === 'management_staff' || value === 'directie') return 'management_staff';
  if (value === 'docenten' || value === 'docent') return 'docenten';
  if (value === 'commissies' || value === 'commissie') return 'commissies';
  return 'docenten';
};

const OverNLBATeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const groupedTeamMembers = TEAM_SECTIONS.map((section) => ({
    ...section,
    members: teamMembers.filter((member) => normalizeTeamGroup(member.group) === section.key)
  })).filter((section) => section.members.length > 0);

  useEffect(() => {
    let isMounted = true;
    const loadTeam = async () => {
      setLoading(true);
      try {
        const data = await contentAPI.getPublicTeamMembers();
        if (!isMounted) return;
        setTeamMembers(data.teamMembers || []);
        setError('');
      } catch (err) {
        if (!isMounted) return;
        setError('Teaminformatie kon niet worden geladen.');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadTeam();
    return () => { isMounted = false; };
  }, []);

  return (
    <OverNLBADetailLayout
      title="Ons Team"
      subtitle="Maak kennis met de mensen achter NLBA Suriname."
      heroImage={banner}
      heroAlt="Team NLBA"
    >
            <h2>Ons Team</h2>
            {loading && <p>Laden...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && teamMembers.length === 0 && (
              <p>Er zijn momenteel nog geen teamleden gepubliceerd.</p>
            )}
            {!loading && !error && teamMembers.length > 0 && (
              <div className="over-nlba-grouped-sections">
                <div className="over-nlba-group-chips" aria-label="Team categorieen">
                  {groupedTeamMembers.map((section) => (
                    <a key={section.key} href={`#team-${section.key}`} className="over-nlba-group-chip">
                      <span>{section.title}</span>
                      <strong>{section.members.length}</strong>
                    </a>
                  ))}
                </div>

                {groupedTeamMembers.map((section) => (
                  <section key={section.key} id={`team-${section.key}`} className="over-nlba-group-section over-nlba-group-panel">
                    <div className="over-nlba-group-head">
                      <h3>{section.title}</h3>
                      <span className="over-nlba-group-count">{section.members.length} leden</span>
                    </div>
                    {section.key !== 'commissies' && (
                      <div className="over-nlba-people-grid">
                        {section.members.map((member) => (
                          <article key={member.id} className="over-nlba-person-card">
                            {member.hasPhoto && (
                              <img
                                src={contentAPI.teamMemberPhotoUrl(member.id)}
                                alt={member.name}
                                className="over-nlba-person-photo"
                                loading="lazy"
                              />
                            )}
                            <h3>{member.name}</h3>
                            <p className="over-nlba-muted">{member.title || '-'}</p>
                            <p>{member.role || '-'}</p>
                            {member.bio && <p>{member.bio}</p>}
                          </article>
                        ))}
                      </div>
                    )}

                    {section.key === 'commissies' && (
                      Object.entries(
                        section.members.reduce((accumulator, member) => {
                          const subSegment = String(member.commissieType || '').trim() || 'Algemene commissie';
                          if (!accumulator[subSegment]) {
                            accumulator[subSegment] = [];
                          }
                          accumulator[subSegment].push(member);
                          return accumulator;
                        }, {})
                      ).map(([subSegment, members]) => (
                        <div key={subSegment} className="over-nlba-committee-subsection">
                          <h4 className="over-nlba-committee-subtitle">{subSegment}</h4>
                          <div className="over-nlba-people-grid">
                            {members.map((member) => (
                              <article key={member.id} className="over-nlba-person-card">
                                {member.hasPhoto && (
                                  <img
                                    src={contentAPI.teamMemberPhotoUrl(member.id)}
                                    alt={member.name}
                                    className="over-nlba-person-photo"
                                    loading="lazy"
                                  />
                                )}
                                <h3>{member.name}</h3>
                                <p className="over-nlba-muted">{member.title || '-'}</p>
                                <p>{member.role || '-'}</p>
                                {member.bio && <p>{member.bio}</p>}
                              </article>
                            ))}
                          </div>
                        </div>
                      ))
                    )}
                  </section>
                ))}
              </div>
            )}
    </OverNLBADetailLayout>
  );
};

export default OverNLBATeam;
